import React from "react";
import { Container, Divider, Grid, Typography, Paper, TextField, Button, CircularProgress, IconButton, Dialog, AppBar, Toolbar } from "@mui/material";
import globals from "../globals";
import { display, styled, width } from "@mui/system";
import TitleTypography from "../components/course_edit/typogrpahy_title";
import EditCourseTF from "../components/course_edit/tf";
import { Theme, useTheme } from '@mui/material/styles';
import RTE from "../components/course_edit/rich_text_editor";
import FileUpload from "../components/course_edit/button_upload_file";
import AddIcon from '@mui/icons-material/Add';
import Box from '@mui/material/Box';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Chip from '@mui/material/Chip';
import FormHelperText from '@mui/material/FormHelperText';
import InputAdornment from '@mui/material/InputAdornment';
import Input from "@mui/material/Input";
import InfoIcon from '@mui/icons-material/Info';
import Tooltip from '@mui/material/Tooltip';
import { useAuth } from "../context/AuthContext";
import { useLocation } from "react-router-dom";
import VisibilityIcon from '@mui/icons-material/Visibility';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import CoursePage from "../course_page/coursePage";
import { DEFAULT_COURSE_PRICE_EUR, formatLevaTooltip } from "../utils";

const PreviewTransition = React.forwardRef(function PreviewTransition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});


const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const levels = [
    'Всички',
    'Начинаещи',
    'Напреднали',
    'Професионалисти',
];

const categories = [
    'Английски език',
    'Български език',
    'Бизнес и Маркетинг',
    'Биология',
    'География',
    'Дизайн',
    'Електротехника',
    'Информационни технологии',
    'Испански език',
    'История',
    'Италиански език',
    'Математика',
    'Немски език',
    'Общообразователни предмети (до 4ти клас)',
    'Популярни курсове',
    'Програмиране',
    'Статистика',
    'Счетоводство',
    // 'Турски език',
    'Финанси',
    'Френски език',
    'Химия',
    'Хоби'
];

const timeStamps = [
    '45',
    '60',
    '90',
    '120'
]

function getStyles(level, levelType, theme) {
    return {
        fontWeight: levelType.includes(level)
            ? theme.typography.fontWeightMedium
            : theme.typography.fontWeightRegular,
    };
}


const OKButton = styled(Button)(() => ({
    color: globals.colors.backgroundColor,
    backgroundColor: globals.colors.lightRed,
    '&:hover': {
        backgroundColor: globals.colors.darkRed,
        color: globals.colors.backgroundColor,
    },
    '&.Mui-selected': {
        color: globals.colors.lightRed,
    },
}))

const CancelButton = styled(Button)(() => ({
    color: globals.colors.textColor,
    backgroundColor: globals.colors.backgroundColor,
    '&:hover': {
        backgroundColor: globals.colors.gray,
        color: globals.colors.backgroundColor,
    },
    '&.Mui-selected': {
        color: globals.colors.lightRed,
    },
}))


const AddTopicButton = styled(Button)(() => ({
    color: globals.colors.backgroundColor,
    backgroundColor: globals.colors.darkBlue,
    '&:hover': {
        backgroundColor: globals.colors.lightBlue,
        color: globals.colors.backgroundColor,
    },
    '&.Mui-selected': {
        color: globals.colors.lightRed,
    },
}))

const EditCourse = () => {
    const { state } = useLocation();
    //console.log('state',state);
    const { user, token } = useAuth();

    const theme = useTheme();
    const [levelType, setLevelType] = React.useState((state) ? state.course.good_for : []);
    const [categoryType, setCategoryType] = React.useState((state) ? state.course.category : []);
    const [timeStamp, setTimeStamp] = React.useState((state) ? state.course.duration : 60);
    const [numStudents, setNumStudents] = React.useState((state) ? state.course.capacity : 1);
    const [publishButtonActive, setPublishButtonActive] = React.useState(false);
    const [draftPublishButtonActive, setDraftPublishButtonActive] = React.useState(false);
    const [showErrorMessage, setShowErrorMessage] = React.useState(false);
    const [files, setFiles] = React.useState([]);
    const [requestUrl, setRequestUrl] = React.useState((state) ? globals.apiUrl + '/courses/' + state.course.id : globals.apiUrl + '/courses/');
    const [requestType, setRequestType] = React.useState((state) ? 'PUT' : 'POST');
    const [publishLoading, setPublishLoading]= React.useState(false);
    const [draftLoading, setDraftLoading]= React.useState(false);


    //console.log("timeStamp", timeStamp);

    const [courseData, setCourseData] = React.useState((state) ? {
        title: state.course.title,
        description: state.course.description,
        price: state.course.price,
        student_requirements: state.course.student_requirements.join('\n'),
        example_topics: state.course.example_topics.join('\n'),
        included_materials: state.course.included_materials.join('\n'),
        good_for: state.course.good_for,
        duration: state.course.duration,
        is_published: state.course.is_published,
        is_approved: state.course.is_approved,
    } : {
        title: '',
        description: '',
        price: DEFAULT_COURSE_PRICE_EUR,
        student_requirements: "",
        example_topics: "",
        included_materials: "",
        good_for: "",
        duration: 45,
        is_published: false,
        is_approved: false,
    });

    const handleChangeLevel = (event) => {
        const {
            target: { value },
        } = event;
        setLevelType(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
    };

    const handleChangeCategory = (event) => {
        const {
            target: { value },
        } = event;
        setCategoryType(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
    };

    const handleChangeTimeStamp = (event) => {
        const {
            target: { value },
        } = event;
        setTimeStamp(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
    };

    const handleChangeFiles = (files) => {
        setFiles(files);
    }

    const [showPreview, setShowPreview] = React.useState(false);
    const [previewImageObjectUrl, setPreviewImageObjectUrl] = React.useState('');

    React.useEffect(() => {
        if (!files || files.length === 0) {
            setPreviewImageObjectUrl('');
            return;
        }
        const url = URL.createObjectURL(files[0]);
        setPreviewImageObjectUrl(url);
        return () => URL.revokeObjectURL(url);
    }, [files]);

    const toLinesArray = (text) => text
        .split('\n')
        .map((line) => line.trim())
        .filter((line) => line.length > 0);

    const buildPreviewCourse = () => {
        const instructorName = user
            ? `${user.first_name || ''} ${user.last_name || ''}`.trim() || 'Учител'
            : 'Учител';
        return {
            id: state?.course?.id ?? 0,
            title: courseData.title || 'Без заглавие',
            description: courseData.description || '',
            price: Number(courseData.price) || 0,
            capacity: Number(numStudents) || 1,
            enrolled_students_count: state?.course?.enrolled_students_count ?? 0,
            student_requirements: toLinesArray(courseData.student_requirements || ''),
            example_topics: toLinesArray(courseData.example_topics || ''),
            included_materials: toLinesArray(courseData.included_materials || ''),
            good_for: Array.isArray(levelType) ? levelType : [],
            category: Array.isArray(categoryType) && categoryType.length > 0 ? categoryType : ['—'],
            image_url: previewImageObjectUrl || state?.course?.image_url || '/eacademiabg-logo.webp',
            duration: Number(timeStamp) || 60,
            instructor_id: user?.id ?? 0,
            instructor_name: instructorName,
            instructor_image_url: user?.image_url || '/noone.webp',
            instructor_description: user?.description || '',
            showChat: false,
            saved: false,
        };
    };

    const handleOpenPreview = () => {
        setShowPreview(true);
    };

    const handleClosePreview = () => {
        setShowPreview(false);
    };

    const handleChangeStudent = (event) => {
        setNumStudents(event.target.value);
    };

    const handlePublishButton = (is_published) => (e) => {
        e.preventDefault();
        if(is_published){
            setPublishLoading(true)
        }else{
            setDraftLoading(true)
        }
        setShowErrorMessage(false);
        setPublishButtonActive(false);
        setDraftPublishButtonActive(false);
        const data = {
            title: courseData.title,
            description: courseData.description,
            price: courseData.price,
            // student_requirements: courseData.student_requirements.split('\n'),
            // example_topics: courseData.example_topics.split('\n'),
            // included_materials: courseData.included_materials.split('\n'),
            good_for: levelType,
            category: categoryType,
            capacity: numStudents,
            duration: timeStamp,
            is_published: is_published,
        }
        if (courseData.student_requirements.length > 0) {
            data.student_requirements = courseData.student_requirements.split('\n');
        }
        if (courseData.example_topics.length > 0) {
            data.example_topics = courseData.example_topics.split('\n');
        }
        if (courseData.included_materials.length > 0) {
            data.included_materials = courseData.included_materials.split('\n');
        }

        const formData = new FormData();
        // Object.keys(data).forEach(key => formData.append(key, data[key]));
        formData.append('data', JSON.stringify(data));
        if (state) {
            if (files.length > 0) {
                formData.append('file', files[0]);
            }
        }
        else {
            formData.append('file', files[0]);
        }

        //console.log(data);

        fetch(requestUrl, {
            method: requestType,
            body: formData,
            headers: {
                'Authorization': `Bearer ${token}`,
                // 'Content-Type': 'multipart/form-data'
            },
        }).then(response => response.json()).then(data => {
            //console.log(data);
            setDraftLoading(false)
            setPublishLoading(false)
            if (data.detail) {
                setPublishButtonActive(false);
                setShowErrorMessage(true);
                return;
            }
            if (is_published) {
                setPublishButtonActive(true);
            }
            else {
                setDraftPublishButtonActive(true);
            }
            if (publishButtonActive) {
                //console.log('publishbutton do');
            }
        }).catch(error => {
            setShowErrorMessage(true);
            console.error('Error:', error);
            setDraftLoading(false)
            setPublishLoading(false)
        });
    }

    const handleChangeCourseData = (event) => {
        setCourseData({
            ...courseData,
            [event.target.id]: event.target.value
        });
    };
    //console.log(courseData);

    return (
        <Container>
            <Grid container direction={'column'}>
                <Typography sx={{ color: globals.colors.lightRed, fontWeight: 'bold', fontSize: 35, mb: 1 }}>{(state) ? 'Редактиране на курс' : 'Създаване на курс'}</Typography>
                <Divider />
                <Grid item sx={{ mt: 2 }}>
                    <TitleTypography value="Заглавие на курса" />
                    <EditCourseTF rowsMax={4} numRows={1} defaultValue={courseData.title} onChange={handleChangeCourseData} idName="title" />
                    <Paper elevation={4} sx={{ maxWidth: 300, mt: 3 }}>
                        <FileUpload helpText={'Добавете изображение'} id={'multi-file-upload-1'} onChange={handleChangeFiles} />
                    </Paper>
                </Grid>
                <Typography sx={{ fontSize: 12, ml: 5, mt: 1 }}>Задължително поле</Typography>

                <Grid item sx={{ mt: 3 }}>
                    <Grid container sx={{ mb: 1 }}>
                        <TitleTypography value="Описание на курса" />
                        <Typography sx={{ mt: 0.5, ml: 2 }}>(каква е целта на курса, какво ще се учи, по какъв метод и т.н.)</Typography>
                    </Grid>
                    <RTE defaultValue={courseData.description} onChange={handleChangeCourseData} idName="description" />
                </Grid>
            </Grid>

            <Grid container sx={{ mt: 3 }} spacing={6}>
                <Grid item sx={12} sm={6}>
                    <TitleTypography value="Примерни теми по време на обучението" />
                    <Typography>(Избройте няколко теми, които може да обхваща курса. Всяка на нов ред.)</Typography>
                    <EditCourseTF multiple numRows={2} rowsMax={10} defaultValue={courseData.example_topics} onChange={handleChangeCourseData} idName="example_topics" />

                    <Typography sx={{ color: globals.colors.darkBlue, fontSize: 20, fontWeight: 'bold', mt: 5 }}>Включени материали
                        <Tooltip title="Материали, които учителят включва в курса. Например: учебници, сборници, онлайн материали за упражнение и други...">
                            <InfoIcon fontSize="small" />
                        </Tooltip>
                    </Typography>
                    <EditCourseTF multiple numRows={2} rowsMax={10} defaultValue={courseData.included_materials} onChange={handleChangeCourseData} idName="included_materials" />

                    <Typography sx={{ color: globals.colors.darkBlue, fontSize: 20, fontWeight: 'bold', mt: 5 }}>Изисквания
                        <Tooltip title="Изисквания към курса. Например: вече платен или изтеглен софтуер, специален учебник, добро настроение, желание за учене...">
                            <InfoIcon fontSize="small" />
                        </Tooltip>
                    </Typography>
                    <EditCourseTF multiple numRows={2} rowsMax={10} defaultValue={courseData.student_requirements} onChange={handleChangeCourseData} idName="student_requirements" />
                    {/* <Paper sx={{ backgroundColor: globals.colors.backgroundColor, mt: 2, }}>
                        <Grid justifyContent={'center'} alignContent={'center'} textAlign={'center'}>
                            <TextField id="title" label="Заглавие на Тема 1." variant="outlined" sx={{
                                backgroundColor: 'white',
                                borderRadius: 1,
                                color: globals.colors.textColor,
                                '& .MuiOutlinedInput-root': {
                                    '& fieldset': {
                                        borderColor: globals.colors.darkRed, // default border color
                                    },
                                    '&:hover fieldset': {
                                        borderColor: globals.colors.darkRed, // border color on hover
                                    },
                                    '&.Mui-focused fieldset': {
                                        borderColor: globals.colors.darkRed, // border color when focused
                                    },
                                }, width: '60vh', mt: 1, mb: 2,
                            }}
                                helperText="Задължително поле"
                            />
                            <FileUpload helpText={'Прикачи файл'} id={'multi-file-upload-2'} />
                        </Grid>
                        <Grid container justifyContent={'end'} alignItems={'end'} textAlign={'end'} sx={{ mr: 3 }}>
                            <CancelButton sx={{ mr: 2, textTransform: 'capitalize' }}>Отказ</CancelButton>
                            <OKButton sx={{ mr: 3 }}>OK</OKButton>
                        </Grid>
                    </Paper>
                    <AddTopicButton sx={{ mt: 2, textTransform: 'capitalize', fontWeight: 'bold', mb: 5 }}><AddIcon />Добавяне на тема</AddTopicButton> */}

                </Grid>

                <Grid item sx={12} sm={6}>
                    <Typography sx={{ color: globals.colors.darkBlue, fontSize: 20, fontWeight: 'bold' }}>
                        Kатегория
                        <Tooltip title="Може курсът да попада в повече от една категория, затова може да изберете повече от една. Ако няма категорията, която търсите се свържете с eAcademiaBg.">
                            <InfoIcon fontSize="small" />
                        </Tooltip>
                    </Typography>
                    <Grid container sx={{ mt: 1, mb: 5 }}>
                        <FormControl sx={{ width: 400 }}>
                            <Select
                                labelId="demo-multiple-chip-label"
                                id="demo-multiple-chip"
                                multiple
                                value={categoryType}
                                onChange={handleChangeCategory}
                                renderValue={(selected) => (
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                        {selected.map((value) => (
                                            <Chip key={value} label={value} />
                                        ))}
                                    </Box>
                                )}
                                MenuProps={MenuProps}
                                sx={{
                                    backgroundColor: globals.colors.backgroundColor,
                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                        borderColor: globals.colors.darkRed, // default border color
                                    },
                                }}
                            >
                                {
                                    categories.map((category) => (
                                        <MenuItem
                                            key={category}
                                            value={category}
                                            style={getStyles(category, categoryType, theme)}
                                        >
                                            {category}
                                        </MenuItem>
                                    ))
                                }
                            </Select>
                            <FormHelperText>Задължително поле</FormHelperText>
                        </FormControl>
                    </Grid>

                    <Typography sx={{ color: globals.colors.darkBlue, fontSize: 20, fontWeight: 'bold' }}>
                        Подходящ за
                        <Tooltip title="Може курсът да е подходящ за повече от едно ниво. Моля, изберете всички нива, които са подходящи.">
                            <InfoIcon fontSize="small" />
                        </Tooltip>
                    </Typography>
                    <Grid container sx={{ mt: 1 }}>
                        <FormControl sx={{ width: 400 }}>
                            {/* <InputLabel id="demo-multiple-chip-label">Chip</InputLabel> */}
                            <Select
                                labelId="demo-multiple-chip-label"
                                id="demo-multiple-chip"
                                multiple
                                value={levelType}
                                onChange={handleChangeLevel}
                                renderValue={(selected) => (
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                        {selected.map((value) => (
                                            <Chip key={value} label={value} />
                                        ))}
                                    </Box>
                                )}
                                MenuProps={MenuProps}
                                sx={{
                                    backgroundColor: globals.colors.backgroundColor,
                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                        borderColor: globals.colors.darkRed, // default border color
                                    },
                                }}
                            >
                                {
                                    levels.map((level) => (
                                        <MenuItem
                                            key={level}
                                            value={level}
                                            style={getStyles(level, levelType, theme)}
                                        >
                                            {level}
                                        </MenuItem>
                                    ))
                                }
                            </Select>
                            <FormHelperText>Задължително поле</FormHelperText>
                        </FormControl>
                    </Grid>
                    <Grid sx={{ mt: 5 }}>
                        <Typography sx={{ color: globals.colors.darkBlue, fontSize: 20, fontWeight: 'bold' }}>
                            Максимален брой ученици,
                            на които можете да преподавате
                            <Tooltip title="Уроците са индивидуални, а не групови. Моля, отбележете на колко ученика на седмица можете да направите индивидуален урок.">
                                <InfoIcon fontSize="small" />

                            </Tooltip>
                        </Typography>

                        <FormControl required sx={{ minWidth: 120, mt: 1 }}>
                            {/* <InputLabel id="demo-simple-select-required-label">Age</InputLabel> */}
                            <Select
                                labelId="demo-simple-select-required-label"
                                id="demo-simple-select-required"
                                value={numStudents}
                                // label="Age *"
                                onChange={handleChangeStudent}
                                sx={{
                                    backgroundColor: globals.colors.backgroundColor,
                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                        borderColor: globals.colors.darkRed, // default border color
                                    },
                                }}
                            >
                                <MenuItem value={1}>1</MenuItem>
                                <MenuItem value={2}>2</MenuItem>
                                <MenuItem value={3}>3</MenuItem>
                                <MenuItem value={4}>4</MenuItem>
                                <MenuItem value={5}>5</MenuItem>
                                <MenuItem value={6}>6</MenuItem>
                                <MenuItem value={7}>7</MenuItem>
                                <MenuItem value={8}>8</MenuItem>
                                <MenuItem value={9}>9</MenuItem>
                                <MenuItem value={10}>10</MenuItem>
                            </Select>
                            <FormHelperText>Задължително поле</FormHelperText>
                        </FormControl>
                    </Grid>
                    <Grid container sx={{ mt: 3 }} sm={8}>
                        <TitleTypography value="Продължителност на един урок" />
                        {/* 45, 60, 90, 120 */}
                        <FormControl required sx={{ minWidth: 120, mt: 1 }}>
                            {/* <InputLabel id="demo-simple-select-required-label">Age</InputLabel> */}
                            <Select
                                labelId="demo-simple-select-required-label"
                                id="demo-simple-select-required"
                                value={timeStamp}
                                // label="Age *"
                                onChange={handleChangeTimeStamp}
                                sx={{
                                    backgroundColor: globals.colors.backgroundColor,
                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                        borderColor: globals.colors.darkRed, // default border color
                                    },
                                }}
                            >
                                <MenuItem value={45}>45 мин</MenuItem>
                                <MenuItem value={60}>1 час</MenuItem>
                                <MenuItem value={90}>1 час 30 мин</MenuItem>
                                <MenuItem value={120}>2 часа</MenuItem>
                            </Select>
                            <FormHelperText>Задължително поле</FormHelperText>
                        </FormControl>
                        {/* <EditCourseTF /> */}
                    </Grid>
                    <Grid container sx={{ mt: 3 }} >
                        <Grid item sm={12}>
                            <Typography sx={{ color: globals.colors.darkBlue, fontSize: 20, fontWeight: 'bold' }}>
                                Цена
                                <Tooltip title="Цената включва 20% комисионна и сумата, която отива при учителя.">
                                    <InfoIcon fontSize="small" />
                                </Tooltip>
                            </Typography>
                        </Grid>
                        <Grid item >
                            <FormControl sx={{ m: 1 }} variant="standard">
                                {/* <InputLabel htmlFor="standard-adornment-amount">Amount</InputLabel> */}
                                <Input
                                    disabled
                                    id="standard-adornment-amount"
                                    value={Number(courseData.price || DEFAULT_COURSE_PRICE_EUR).toFixed(2)}
                                    startAdornment={<InputAdornment position="start">€</InputAdornment>}
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <Tooltip title={formatLevaTooltip(Number(courseData.price) || DEFAULT_COURSE_PRICE_EUR)}>
                                                <InfoIcon fontSize="small" sx={{ color: globals.colors.darkBlue }} />
                                            </Tooltip>
                                        </InputAdornment>
                                    }
                                />
                                <FormHelperText>При желание за сменяне на цената, моля консултирайте се с екипа на eAcademiaBg.</FormHelperText>
                            </FormControl>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid container spacing={2} justifyContent={'center'} sx={{ mt: 2 }}>
                    <Grid item>
                        <Button
                            variant='contained'
                            type='submit'
                            size='large'
                            disabled={publishLoading || draftLoading}
                            sx={{
                            mt: 3, px: 7, backgroundColor: globals.colors.lightRed, '&:hover': {
                                backgroundColor: globals.colors.darkRed,
                            }, mb: 5
                            }}
                            onClick={handlePublishButton(true)}
                        >
                            {publishLoading ? <CircularProgress size={25} sx={{ color: globals.colors.backgroundColor }} /> : "Публикувай"}
                        </Button>
                        {(publishButtonActive) ?
                            <Typography sx={{ mt: 1, color: globals.colors.gray }}>{user.admin == 'admin' ? "Успешно публикувахте курса!" : (courseData.is_approved ? "Успешно публикувахте курса!" : "Успешно изпратена заявка за \n публикуване на курса!")}</Typography> : null
                        }
                    </Grid>
                    <Grid item>
                        <Button
                            variant='contained'
                            type='submit'
                            size='large'
                            disabled={publishLoading || draftLoading}
                            sx={{
                            mt: 3, px: 7, backgroundColor: globals.colors.darkBlue, '&:hover': {
                                backgroundColor: globals.colors.lightBlue,
                            }
                            }}
                            onClick={handlePublishButton(false)}
                        >
                            {draftLoading ? <CircularProgress size={25} sx={{ color: globals.colors.backgroundColor }} /> : "Чернова"}
                        </Button>
                        {(draftPublishButtonActive) ?
                            <Typography sx={{ mt: 1, color: globals.colors.gray }}>Успешно запазихте черновата!</Typography> : null
                        }
                    </Grid>
                    <Grid item>
                        <Button
                            variant='outlined'
                            size='large'
                            disabled={publishLoading || draftLoading}
                            startIcon={<VisibilityIcon />}
                            onClick={handleOpenPreview}
                            sx={{
                                mt: 3, px: 7,
                                color: globals.colors.lightGreen,
                                borderColor: globals.colors.lightGreen,
                                '&:hover': {
                                    color: globals.colors.darkGreen,
                                    borderColor: globals.colors.darkGreen,
                                    backgroundColor: 'transparent',
                                },
                            }}
                        >
                            Преглед
                        </Button>
                    </Grid>
                    {showErrorMessage ? <Typography sx={{ mt: 1, color: globals.colors.red }}>Възникна грешка при публикуването на курса. Моля, проверете дали сте запълнили всички полета правилно.</Typography> : null}
                </Grid>
            </Grid>

            <Dialog
                fullScreen
                open={showPreview}
                onClose={handleClosePreview}
                TransitionComponent={PreviewTransition}
            >
                <AppBar sx={{ position: 'sticky', backgroundColor: globals.colors.darkBlue }}>
                    <Toolbar>
                        <Typography sx={{ flex: 1, fontWeight: 'bold' }} variant="h6" component="div">
                            Преглед на курса (текущи промени, без запис)
                        </Typography>
                        <IconButton
                            edge="end"
                            color="inherit"
                            onClick={handleClosePreview}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <Box sx={{ py: 3, backgroundColor: globals.colors.backgroundColor, minHeight: '100%' }}>
                    {showPreview ? <CoursePage course={buildPreviewCourse()} showPublish={false} /> : null}
                </Box>
            </Dialog>
        </Container >
    );
}

export default EditCourse;